const LogoIcon = ({ className, style }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g clipPath="url(#clip0_841_5974)">
        <g clipPath="url(#clip1_841_5974)">
          <path
            d="M54.4867 -31.1524C55.2353 -31.8973 55.6586 -32.2857 56.1388 -32.4417C56.6121 -32.5955 57.1219 -32.5955 57.5952 -32.4417C58.1333 -32.2668 58.5999 -31.8002 59.5332 -30.8669L70.8646 -19.5355C71.7979 -18.6023 72.2645 -18.1356 72.4394 -17.5975C72.5932 -17.1242 72.5932 -16.6144 72.4394 -16.1411C72.2834 -15.6609 71.895 -15.2377 71.1501 -14.489L54.4867 -31.1524Z"
            fill="currentColor"
          />
          <path
            d="M53.2962 -29.9623L52.1059 -28.7721L68.7697 -12.1082L69.96 -13.2985L53.2962 -29.9623Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50.9156 -27.5818L67.5795 -10.9179L59.5333 -2.8717C59.1833 -2.52173 58.8989 -2.23733 58.6518 -2.00937C58.5067 -1.87555 58.3745 -1.76112 58.2493 -1.66422C58.019 -1.48603 57.813 -1.36744 57.5949 -1.29665C57.122 -1.14307 56.612 -1.14287 56.1384 -1.29665C55.6006 -1.47159 55.134 -1.93822 54.2007 -2.87148L52.2841 -4.78809C50.9128 -6.15938 48.6948 -6.16841 47.3123 -4.81517L32.0153 10.4818C30.6693 11.8648 30.6807 14.0774 32.0496 15.4463L33.966 17.3627C34.8992 18.2959 35.3659 18.7626 35.5408 19.3004C35.6356 19.5929 35.672 19.8987 35.6498 20.2011C35.636 20.3891 35.5996 20.5756 35.5408 20.7569C35.443 21.0577 35.2542 21.336 34.9436 21.6861C34.6985 21.9625 34.3775 22.2835 33.9658 22.6952L29.55 27.111L26.9162 24.4771C28.9646 21.2847 28.5927 16.9886 25.8006 14.1965C23.0085 11.4044 18.7124 11.0326 15.52 13.081L12.8861 10.4471L17.3019 6.03136C17.8572 5.47604 18.2474 5.08588 18.5859 4.82388C18.8161 4.64569 19.0222 4.5271 19.2402 4.45631C19.7132 4.30273 20.2231 4.30253 20.6967 4.45631C21.2345 4.63125 21.7012 5.09788 22.6344 6.03116L24.551 7.94775C25.9314 9.32813 28.1698 9.32813 29.5502 7.94775L44.8027 -7.30471C46.1659 -8.68643 46.1602 -10.912 44.7856 -12.2866L42.8692 -14.203C41.9359 -15.1363 41.4693 -15.6029 41.2943 -16.1407C41.1996 -16.4333 41.1631 -16.739 41.1853 -17.0415C41.1991 -17.2294 41.2356 -17.416 41.2943 -17.5972C41.347 -17.7592 41.4261 -17.9147 41.5363 -18.0783C41.7654 -18.4185 42.1294 -18.7942 42.6709 -19.3369L50.9156 -27.5818ZM50.9156 -10.9179C52.559 -9.27449 55.2236 -9.27449 56.867 -10.9179C58.5104 -12.5613 58.5104 -15.2259 56.867 -16.8693C55.2236 -18.5127 52.559 -18.5127 50.9156 -16.8693C49.2722 -15.2259 49.2722 -12.5613 50.9156 -10.9179Z"
            fill="currentColor"
          />
          <path
            d="M13.0204 15.5805L10.3866 12.9467L5.97079 17.3625C5.40285 17.9304 5.00782 18.3254 4.74602 18.669C4.70595 18.7217 4.66893 18.7734 4.63496 18.824C4.59732 18.8799 4.56356 18.9349 4.53325 18.9892C4.49501 19.0575 4.46205 19.1255 4.4348 19.1934C4.42056 19.2288 4.40754 19.2646 4.39574 19.3008C4.24216 19.7738 4.24196 20.2837 4.39574 20.7573C4.50091 21.0813 4.71205 21.3795 5.06762 21.7693C5.30216 22.0266 5.59956 22.324 5.97059 22.695L17.3021 34.0265C17.8802 34.6046 18.2791 35.0035 18.6269 35.2651C18.8407 35.426 19.035 35.5349 19.2398 35.6014C19.7134 35.7552 20.2234 35.7549 20.6963 35.6014C20.8314 35.5574 20.9614 35.4954 21.0956 35.4124C21.3464 35.2572 21.6109 35.0286 21.9443 34.7086C22.1452 34.5157 22.3714 34.2895 22.6347 34.0263L27.0504 29.6106L24.4166 26.9767C21.2242 29.0251 16.928 28.6533 14.1359 25.8612C11.3438 23.0691 10.972 18.7729 13.0204 15.5805Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_841_5974">
          <rect width="40" height="40" fill="white" />
        </clipPath>
        <clipPath id="clip1_841_5974">
          <rect
            width="23.5702"
            height="30.6315"
            fill="white"
            transform="translate(22.4927 0.840576) rotate(45)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoIcon;
